import { DataBean } from "../DataBean";

export class DeliveryCertificate extends DataBean {

    public async updateDeliveryCertificate(bean: any): Promise<any> {
        return this.getCustomService(
            "ProcessContractERP",
            "com.orange.finance.processcontract.bean.DeliveryCertificate_updateDeliveryCertificate_com.orange.finance.processcontract.bean.DeliveryCertificate",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "com.orange.finance.processcontract.bean.DeliveryCertificate"
                }
            ]
        );
    }

}